import { useParams } from 'react-router'
import toInteger from 'lodash/toInteger'
import { PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE } from '@klear/constants'
import { Button } from '@klear/ui/components/button'
import { Card } from '@klear/ui/components/card'
import { ProofOfAcceptanceEventForm } from '@klear/order-event-ui/event-handlers/ProofOfAcceptanceEventForm'
import { useEventFormBootstrap } from '@klear/order-event-ui/event-shared/use-event-form-bootstrap'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import type { ReceivableStepCtx } from '@/app/receivable/workflow/ReceivableWizardContext'

export default function ProofOfAcceptanceStep({ ctx }: WizardStepComponentProps<ReceivableStepCtx>) {
  const { traderId: traderIdParam } = useParams<{ traderId?: string }>()
  const traderId = toInteger(traderIdParam)
  const { form, onProofSaved, onProofSkipped } = ctx

  const { bootstrap, isLoading } = useEventFormBootstrap({
    eventType: PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
    parentEventId: form.invoiceEventId ?? undefined,
    traderId
  })

  if (form.invoiceEventId == null || form.orderId == null) {
    return <div className="text-sm text-muted-foreground">Save the invoice first.</div>
  }
  if (isLoading || bootstrap == null) {
    return <div className="text-sm text-muted-foreground">Loading invoice…</div>
  }

  return (
    <div className="space-y-6 w-full max-w-2xl">
      <Card className="p-6 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold text-foreground">Proof of acceptance</h2>
            <p className="text-sm text-muted-foreground">
              Optional. Attach supporting documents for this invoice now, or skip and add them later.
            </p>
          </div>
          <Button type="button" variant="ghost" onClick={onProofSkipped}>
            Skip for now
          </Button>
        </div>
        <ProofOfAcceptanceEventForm
          bootstrap={bootstrap}
          orderId={form.orderId}
          traderId={traderId}
          onSuccess={onProofSaved}
          onCancel={onProofSkipped}
        />
      </Card>
    </div>
  )
}
